// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/auth/v1/auth.proto (package mono.auth.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.auth.v1.LoginRequest
 */ export class LoginRequest extends Message {
    static fromBinary(bytes, options) {
        return new LoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoginRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string email = 1;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string password = 2;
   */ _define_property(this, "password", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoginRequest, "runtime", proto3);
_define_property(LoginRequest, "typeName", "mono.auth.v1.LoginRequest");
_define_property(LoginRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "password",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.LoginResponse
 */ export class LoginResponse extends Message {
    static fromBinary(bytes, options) {
        return new LoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoginResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0), /**
   * @generated from field: string access_token = 2;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: string refresh_token = 3;
   */ _define_property(this, "refreshToken", ""), /**
   * @generated from field: string token_type = 4;
   */ _define_property(this, "tokenType", ""), /**
   * @generated from field: int32 expires_in = 5;
   */ _define_property(this, "expiresIn", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LoginResponse, "runtime", proto3);
_define_property(LoginResponse, "typeName", "mono.auth.v1.LoginResponse");
_define_property(LoginResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        },
        {
            no: 2,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "refresh_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "token_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expires_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.RegisterRequest
 */ export class RegisterRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegisterRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string email = 1;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string password = 2;
   */ _define_property(this, "password", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterRequest, "runtime", proto3);
_define_property(RegisterRequest, "typeName", "mono.auth.v1.RegisterRequest");
_define_property(RegisterRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "password",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.RegisterResponse
 */ export class RegisterResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegisterResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0), /**
   * @generated from field: string access_token = 2;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: string refresh_token = 3;
   */ _define_property(this, "refreshToken", ""), /**
   * @generated from field: string token_type = 4;
   */ _define_property(this, "tokenType", ""), /**
   * @generated from field: int32 expires_in = 5;
   */ _define_property(this, "expiresIn", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterResponse, "runtime", proto3);
_define_property(RegisterResponse, "typeName", "mono.auth.v1.RegisterResponse");
_define_property(RegisterResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        },
        {
            no: 2,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "refresh_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "token_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expires_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.RefreshRequest
 */ export class RefreshRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string refresh_token = 1;
   */ _define_property(this, "refreshToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshRequest, "runtime", proto3);
_define_property(RefreshRequest, "typeName", "mono.auth.v1.RefreshRequest");
_define_property(RefreshRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "refresh_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.RefreshResponse
 */ export class RefreshResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string access_token = 1;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: string refresh_token = 2;
   */ _define_property(this, "refreshToken", ""), /**
   * @generated from field: string token_type = 3;
   */ _define_property(this, "tokenType", ""), /**
   * @generated from field: int32 expires_in = 4;
   */ _define_property(this, "expiresIn", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshResponse, "runtime", proto3);
_define_property(RefreshResponse, "typeName", "mono.auth.v1.RefreshResponse");
_define_property(RefreshResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "refresh_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "token_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expires_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.LogoutRequest
 */ export class LogoutRequest extends Message {
    static fromBinary(bytes, options) {
        return new LogoutRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogoutRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogoutRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogoutRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogoutRequest, "runtime", proto3);
_define_property(LogoutRequest, "typeName", "mono.auth.v1.LogoutRequest");
_define_property(LogoutRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.auth.v1.LogoutResponse
 */ export class LogoutResponse extends Message {
    static fromBinary(bytes, options) {
        return new LogoutResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogoutResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogoutResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogoutResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogoutResponse, "runtime", proto3);
_define_property(LogoutResponse, "typeName", "mono.auth.v1.LogoutResponse");
_define_property(LogoutResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetMeRequest
 */ export class GetMeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetMeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMeRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMeRequest, "runtime", proto3);
_define_property(GetMeRequest, "typeName", "mono.auth.v1.GetMeRequest");
_define_property(GetMeRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.auth.v1.GetMeResponse
 */ export class GetMeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetMeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetMeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetMeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetMeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0), /**
   * The user's tenant identity — name and nickname for tenant-scoped display.
   *
   * @generated from field: mono.auth.v1.TenantInfo tenant = 2;
   */ _define_property(this, "tenant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetMeResponse, "runtime", proto3);
_define_property(GetMeResponse, "typeName", "mono.auth.v1.GetMeResponse");
_define_property(GetMeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        },
        {
            no: 2,
            name: "tenant",
            kind: "message",
            T: TenantInfo
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetProvidersRequest
 */ export class GetProvidersRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProvidersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProvidersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProvidersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProvidersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_slug = 1;
   */ _define_property(this, "tenantSlug", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProvidersRequest, "runtime", proto3);
_define_property(GetProvidersRequest, "typeName", "mono.auth.v1.GetProvidersRequest");
_define_property(GetProvidersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_slug",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetProvidersResponse
 */ export class GetProvidersResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProvidersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProvidersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProvidersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProvidersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.TenantInfo tenant = 1;
   */ _define_property(this, "tenant", void 0), /**
   * @generated from field: repeated mono.auth.v1.ProviderInfo providers = 2;
   */ _define_property(this, "providers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProvidersResponse, "runtime", proto3);
_define_property(GetProvidersResponse, "typeName", "mono.auth.v1.GetProvidersResponse");
_define_property(GetProvidersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant",
            kind: "message",
            T: TenantInfo
        },
        {
            no: 2,
            name: "providers",
            kind: "message",
            T: ProviderInfo,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetJWKSRequest
 */ export class GetJWKSRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetJWKSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJWKSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJWKSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJWKSRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJWKSRequest, "runtime", proto3);
_define_property(GetJWKSRequest, "typeName", "mono.auth.v1.GetJWKSRequest");
_define_property(GetJWKSRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.auth.v1.GetJWKSResponse
 */ export class GetJWKSResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetJWKSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetJWKSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetJWKSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetJWKSResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Raw JWKS JSON response
   *
   * @generated from field: bytes jwks_json = 1;
   */ _define_property(this, "jwksJson", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetJWKSResponse, "runtime", proto3);
_define_property(GetJWKSResponse, "typeName", "mono.auth.v1.GetJWKSResponse");
_define_property(GetJWKSResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "jwks_json",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.ListUsersForSharingRequest
 */ export class ListUsersForSharingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListUsersForSharingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersForSharingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersForSharingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersForSharingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string query = 2;
   */ _define_property(this, "query", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUsersForSharingRequest, "runtime", proto3);
_define_property(ListUsersForSharingRequest, "typeName", "mono.auth.v1.ListUsersForSharingRequest");
_define_property(ListUsersForSharingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.ListUsersForSharingResponse
 */ export class ListUsersForSharingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListUsersForSharingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersForSharingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersForSharingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersForSharingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.auth.v1.UserSummary users = 1;
   */ _define_property(this, "users", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUsersForSharingResponse, "runtime", proto3);
_define_property(ListUsersForSharingResponse, "typeName", "mono.auth.v1.ListUsersForSharingResponse");
_define_property(ListUsersForSharingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "users",
            kind: "message",
            T: UserSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetSSOConfigRequest
 */ export class GetSSOConfigRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSSOConfigRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSSOConfigRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSSOConfigRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSSOConfigRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Optional tenant ID for service-to-service calls (X-Admin-Secret auth).
   * Ignored for JWT auth (uses token's tenant).
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSSOConfigRequest, "runtime", proto3);
_define_property(GetSSOConfigRequest, "typeName", "mono.auth.v1.GetSSOConfigRequest");
_define_property(GetSSOConfigRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateSSOConfigRequest
 */ export class UpdateSSOConfigRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSSOConfigRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSSOConfigRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSSOConfigRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSSOConfigRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.SSOConfig config = 1;
   */ _define_property(this, "config", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSSOConfigRequest, "runtime", proto3);
_define_property(UpdateSSOConfigRequest, "typeName", "mono.auth.v1.UpdateSSOConfigRequest");
_define_property(UpdateSSOConfigRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config",
            kind: "message",
            T: SSOConfig
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetSSOConfigResponse
 */ export class GetSSOConfigResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSSOConfigResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSSOConfigResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSSOConfigResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSSOConfigResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.SSOConfig config = 1;
   */ _define_property(this, "config", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSSOConfigResponse, "runtime", proto3);
_define_property(GetSSOConfigResponse, "typeName", "mono.auth.v1.GetSSOConfigResponse");
_define_property(GetSSOConfigResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config",
            kind: "message",
            T: SSOConfig
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateSSOConfigResponse
 */ export class UpdateSSOConfigResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSSOConfigResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSSOConfigResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSSOConfigResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSSOConfigResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.SSOConfig config = 1;
   */ _define_property(this, "config", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSSOConfigResponse, "runtime", proto3);
_define_property(UpdateSSOConfigResponse, "typeName", "mono.auth.v1.UpdateSSOConfigResponse");
_define_property(UpdateSSOConfigResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "config",
            kind: "message",
            T: SSOConfig
        }
    ]));
/**
 * GetSharePointOAuthConfigRequest fetches the public SharePoint OAuth-start
 * fields. tenant_id is optional for JWT callers (the JWT's tenant wins);
 * required for service-to-service callers using X-Admin-Secret.
 *
 * @generated from message mono.auth.v1.GetSharePointOAuthConfigRequest
 */ export class GetSharePointOAuthConfigRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSharePointOAuthConfigRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSharePointOAuthConfigRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSharePointOAuthConfigRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSharePointOAuthConfigRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSharePointOAuthConfigRequest, "runtime", proto3);
_define_property(GetSharePointOAuthConfigRequest, "typeName", "mono.auth.v1.GetSharePointOAuthConfigRequest");
_define_property(GetSharePointOAuthConfigRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetSharePointOAuthConfigResponse intentionally carries ONLY non-secret
 * fields. client_secret is omitted by construction so this RPC cannot leak
 * it regardless of authorization mistakes elsewhere.
 *
 * @generated from message mono.auth.v1.GetSharePointOAuthConfigResponse
 */ export class GetSharePointOAuthConfigResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSharePointOAuthConfigResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSharePointOAuthConfigResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSharePointOAuthConfigResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSharePointOAuthConfigResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool sharepoint_enabled = 1;
   */ _define_property(this, "sharepointEnabled", false), /**
   * @generated from field: string client_id = 2;
   */ _define_property(this, "clientId", ""), /**
   * @generated from field: string authority = 3;
   */ _define_property(this, "authority", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string redirect_uri = 5;
   */ _define_property(this, "redirectUri", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSharePointOAuthConfigResponse, "runtime", proto3);
_define_property(GetSharePointOAuthConfigResponse, "typeName", "mono.auth.v1.GetSharePointOAuthConfigResponse");
_define_property(GetSharePointOAuthConfigResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sharepoint_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "authority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "redirect_uri",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * User represents a user account.
 *
 * @generated from message mono.auth.v1.User
 */ export class User extends Message {
    static fromBinary(bytes, options) {
        return new User().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new User().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new User().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(User, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated string roles = 5;
   */ _define_property(this, "roles", []), /**
   * @generated from field: repeated string scopes = 6;
   */ _define_property(this, "scopes", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: bool active = 9;
   */ _define_property(this, "active", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(User, "runtime", proto3);
_define_property(User, "typeName", "mono.auth.v1.User");
_define_property(User, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "scopes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * UserSummary is a lightweight user representation for sharing.
 *
 * @generated from message mono.auth.v1.UserSummary
 */ export class UserSummary extends Message {
    static fromBinary(bytes, options) {
        return new UserSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UserSummary, "runtime", proto3);
_define_property(UserSummary, "typeName", "mono.auth.v1.UserSummary");
_define_property(UserSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * TenantInfo describes a tenant.
 *
 * @generated from message mono.auth.v1.TenantInfo
 */ export class TenantInfo extends Message {
    static fromBinary(bytes, options) {
        return new TenantInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TenantInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TenantInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TenantInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string slug = 1;
   */ _define_property(this, "slug", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * Short display alias ("" = none set; display falls back to name).
   *
   * @generated from field: string nickname = 3;
   */ _define_property(this, "nickname", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TenantInfo, "runtime", proto3);
_define_property(TenantInfo, "typeName", "mono.auth.v1.TenantInfo");
_define_property(TenantInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "slug",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "nickname",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProviderInfo describes an available SSO provider.
 *
 * @generated from message mono.auth.v1.ProviderInfo
 */ export class ProviderInfo extends Message {
    static fromBinary(bytes, options) {
        return new ProviderInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProviderInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProviderInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProviderInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string type = 1;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string login_url = 3;
   */ _define_property(this, "loginUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProviderInfo, "runtime", proto3);
_define_property(ProviderInfo, "typeName", "mono.auth.v1.ProviderInfo");
_define_property(ProviderInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "login_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SSOConfig holds SSO configuration for a tenant.
 *
 * @generated from message mono.auth.v1.SSOConfig
 */ export class SSOConfig extends Message {
    static fromBinary(bytes, options) {
        return new SSOConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SSOConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SSOConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SSOConfig, a, b);
    }
    constructor(data){
        super(), /**
   * OAuth settings
   *
   * @generated from field: string google_client_id = 1;
   */ _define_property(this, "googleClientId", ""), /**
   * @generated from field: string google_client_secret = 2;
   */ _define_property(this, "googleClientSecret", ""), /**
   * @generated from field: string microsoft_client_id = 3;
   */ _define_property(this, "microsoftClientId", ""), /**
   * @generated from field: string microsoft_client_secret = 4;
   */ _define_property(this, "microsoftClientSecret", ""), /**
   * @generated from field: string microsoft_tenant_id = 8;
   */ _define_property(this, "microsoftTenantId", ""), /**
   * Provider toggles
   *
   * @generated from field: bool email_password_enabled = 9;
   */ _define_property(this, "emailPasswordEnabled", false), /**
   * @generated from field: bool google_enabled = 10;
   */ _define_property(this, "googleEnabled", false), /**
   * @generated from field: bool microsoft_enabled = 11;
   */ _define_property(this, "microsoftEnabled", false), /**
   * Google Workspace SAML
   *
   * @generated from field: bool google_saml_enabled = 12;
   */ _define_property(this, "googleSamlEnabled", false), /**
   * @generated from field: string google_saml_metadata_url = 13;
   */ _define_property(this, "googleSamlMetadataUrl", ""), /**
   * @generated from field: string google_saml_entity_id = 14;
   */ _define_property(this, "googleSamlEntityId", ""), /**
   * @generated from field: string google_saml_sso_url = 15;
   */ _define_property(this, "googleSamlSsoUrl", ""), /**
   * @generated from field: string google_saml_certificate = 16;
   */ _define_property(this, "googleSamlCertificate", ""), /**
   * @generated from field: string google_saml_email_attribute = 17;
   */ _define_property(this, "googleSamlEmailAttribute", ""), /**
   * Microsoft Azure SAML
   *
   * @generated from field: bool microsoft_saml_enabled = 18;
   */ _define_property(this, "microsoftSamlEnabled", false), /**
   * @generated from field: string microsoft_saml_metadata_url = 19;
   */ _define_property(this, "microsoftSamlMetadataUrl", ""), /**
   * @generated from field: string microsoft_saml_entity_id = 20;
   */ _define_property(this, "microsoftSamlEntityId", ""), /**
   * @generated from field: string microsoft_saml_sso_url = 21;
   */ _define_property(this, "microsoftSamlSsoUrl", ""), /**
   * @generated from field: string microsoft_saml_certificate = 22;
   */ _define_property(this, "microsoftSamlCertificate", ""), /**
   * @generated from field: string microsoft_saml_email_attribute = 23;
   */ _define_property(this, "microsoftSamlEmailAttribute", ""), /**
   * SharePoint OAuth Configuration
   *
   * @generated from field: bool sharepoint_enabled = 24;
   */ _define_property(this, "sharepointEnabled", false), /**
   * @generated from field: string sharepoint_client_id = 25;
   */ _define_property(this, "sharepointClientId", ""), /**
   * @generated from field: string sharepoint_client_secret = 26;
   */ _define_property(this, "sharepointClientSecret", ""), /**
   * @generated from field: string sharepoint_authority = 27;
   */ _define_property(this, "sharepointAuthority", ""), /**
   * @generated from field: string sharepoint_scope = 28;
   */ _define_property(this, "sharepointScope", ""), /**
   * @generated from field: string sharepoint_redirect_uri = 29;
   */ _define_property(this, "sharepointRedirectUri", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SSOConfig, "runtime", proto3);
_define_property(SSOConfig, "typeName", "mono.auth.v1.SSOConfig");
_define_property(SSOConfig, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "google_client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "google_client_secret",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "microsoft_client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "microsoft_client_secret",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "microsoft_tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "email_password_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "google_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "microsoft_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "google_saml_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "google_saml_metadata_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "google_saml_entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "google_saml_sso_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "google_saml_certificate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "google_saml_email_attribute",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "microsoft_saml_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "microsoft_saml_metadata_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "microsoft_saml_entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "microsoft_saml_sso_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "microsoft_saml_certificate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "microsoft_saml_email_attribute",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "sharepoint_enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "sharepoint_client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "sharepoint_client_secret",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "sharepoint_authority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "sharepoint_scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "sharepoint_redirect_uri",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.ListUsersRequest
 */ export class ListUsersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListUsersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Optional: filter to a specific tenant. Empty means all tenants.
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional: search string matched against name and email.
   *
   * @generated from field: string search = 2;
   */ _define_property(this, "search", ""), /**
   * Page number, 1-indexed. Defaults to 1.
   *
   * @generated from field: int32 page = 3;
   */ _define_property(this, "page", 0), /**
   * Page size. Defaults to 50, max 100.
   *
   * @generated from field: int32 page_size = 4;
   */ _define_property(this, "pageSize", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUsersRequest, "runtime", proto3);
_define_property(ListUsersRequest, "typeName", "mono.auth.v1.ListUsersRequest");
_define_property(ListUsersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.ListUsersResponse
 */ export class ListUsersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListUsersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUsersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUsersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUsersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.auth.v1.User users = 1;
   */ _define_property(this, "users", []), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0), /**
   * @generated from field: int32 page = 3;
   */ _define_property(this, "page", 0), /**
   * @generated from field: int32 page_size = 4;
   */ _define_property(this, "pageSize", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUsersResponse, "runtime", proto3);
_define_property(ListUsersResponse, "typeName", "mono.auth.v1.ListUsersResponse");
_define_property(ListUsersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "users",
            kind: "message",
            T: User,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetUserRequest
 */ export class GetUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUserRequest, "runtime", proto3);
_define_property(GetUserRequest, "typeName", "mono.auth.v1.GetUserRequest");
_define_property(GetUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.GetUserResponse
 */ export class GetUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUserResponse, "runtime", proto3);
_define_property(GetUserResponse, "typeName", "mono.auth.v1.GetUserResponse");
_define_property(GetUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        }
    ]));
/**
 * @generated from message mono.auth.v1.CreateUserRequest
 */ export class CreateUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string email = 1;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string password = 3;
   */ _define_property(this, "password", ""), /**
   * Role to assign: "admin", "write", "manager", "user".
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", ""), /**
   * Optional SDS functional-area roster stamped onto the user's JWT `function`
   * claim (Delivery | Contracts | Finance | … | LegalCounsel). Empty = no
   * functional ownership. The LegalCounsel value is the attorney claim the
   * Phase 3c legal lane gates on (legal_derived_roles.is_admitted_attorney);
   * exposing it here lets admin tooling seed an admitted attorney without a
   * separate mutation. Unknown values are dropped at JWT mint.
   *
   * @generated from field: repeated string function = 6;
   */ _define_property(this, "function", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUserRequest, "runtime", proto3);
_define_property(CreateUserRequest, "typeName", "mono.auth.v1.CreateUserRequest");
_define_property(CreateUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "password",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "function",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.auth.v1.CreateUserResponse
 */ export class CreateUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateUserResponse, "runtime", proto3);
_define_property(CreateUserResponse, "typeName", "mono.auth.v1.CreateUserResponse");
_define_property(CreateUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserRoleRequest
 */ export class UpdateUserRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * New role: "admin", "write", "manager", "user".
   *
   * @generated from field: string role = 2;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserRoleRequest, "runtime", proto3);
_define_property(UpdateUserRoleRequest, "typeName", "mono.auth.v1.UpdateUserRoleRequest");
_define_property(UpdateUserRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserRoleResponse
 */ export class UpdateUserRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserRoleResponse, "runtime", proto3);
_define_property(UpdateUserRoleResponse, "typeName", "mono.auth.v1.UpdateUserRoleResponse");
_define_property(UpdateUserRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserStatusRequest
 */ export class UpdateUserStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * true = active, false = deactivated.
   *
   * @generated from field: bool active = 2;
   */ _define_property(this, "active", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserStatusRequest, "runtime", proto3);
_define_property(UpdateUserStatusRequest, "typeName", "mono.auth.v1.UpdateUserStatusRequest");
_define_property(UpdateUserStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserStatusResponse
 */ export class UpdateUserStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserStatusResponse, "runtime", proto3);
_define_property(UpdateUserStatusResponse, "typeName", "mono.auth.v1.UpdateUserStatusResponse");
_define_property(UpdateUserStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserRequest
 */ export class UpdateUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string email = 3;
   */ _define_property(this, "email", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserRequest, "runtime", proto3);
_define_property(UpdateUserRequest, "typeName", "mono.auth.v1.UpdateUserRequest");
_define_property(UpdateUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserResponse
 */ export class UpdateUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.auth.v1.User user = 1;
   */ _define_property(this, "user", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserResponse, "runtime", proto3);
_define_property(UpdateUserResponse, "typeName", "mono.auth.v1.UpdateUserResponse");
_define_property(UpdateUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user",
            kind: "message",
            T: User
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserPasswordRequest
 */ export class UpdateUserPasswordRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserPasswordRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserPasswordRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserPasswordRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserPasswordRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string new_password = 2;
   */ _define_property(this, "newPassword", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserPasswordRequest, "runtime", proto3);
_define_property(UpdateUserPasswordRequest, "typeName", "mono.auth.v1.UpdateUserPasswordRequest");
_define_property(UpdateUserPasswordRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_password",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.UpdateUserPasswordResponse
 */ export class UpdateUserPasswordResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateUserPasswordResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateUserPasswordResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateUserPasswordResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateUserPasswordResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateUserPasswordResponse, "runtime", proto3);
_define_property(UpdateUserPasswordResponse, "typeName", "mono.auth.v1.UpdateUserPasswordResponse");
_define_property(UpdateUserPasswordResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.auth.v1.DeleteUserRequest
 */ export class DeleteUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * hard=false (default): soft-delete (deactivate + GORM soft-delete). hard=true:
   * permanent HardDelete. Both write a durable audit line (R18).
   *
   * @generated from field: bool hard = 2;
   */ _define_property(this, "hard", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteUserRequest, "runtime", proto3);
_define_property(DeleteUserRequest, "typeName", "mono.auth.v1.DeleteUserRequest");
_define_property(DeleteUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.auth.v1.DeleteUserResponse
 */ export class DeleteUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteUserResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteUserResponse, "runtime", proto3);
_define_property(DeleteUserResponse, "typeName", "mono.auth.v1.DeleteUserResponse");
_define_property(DeleteUserResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.auth.v1.ResolveUserNamesRequest
 */ export class ResolveUserNamesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveUserNamesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveUserNamesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveUserNamesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveUserNamesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string user_ids = 1;
   */ _define_property(this, "userIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveUserNamesRequest, "runtime", proto3);
_define_property(ResolveUserNamesRequest, "typeName", "mono.auth.v1.ResolveUserNamesRequest");
_define_property(ResolveUserNamesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.auth.v1.ResolveUserNamesResponse
 */ export class ResolveUserNamesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveUserNamesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveUserNamesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveUserNamesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveUserNamesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Only ids that resolved. Missing/foreign-tenant ids are absent, not errors.
   *
   * @generated from field: repeated mono.auth.v1.ResolvedUserName users = 1;
   */ _define_property(this, "users", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveUserNamesResponse, "runtime", proto3);
_define_property(ResolveUserNamesResponse, "typeName", "mono.auth.v1.ResolveUserNamesResponse");
_define_property(ResolveUserNamesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "users",
            kind: "message",
            T: ResolvedUserName,
            repeated: true
        }
    ]));
/**
 * ResolvedUserName carries the minimum needed to label an id in a UI - never
 * email, roles, or scopes.
 *
 * @generated from message mono.auth.v1.ResolvedUserName
 */ export class ResolvedUserName extends Message {
    static fromBinary(bytes, options) {
        return new ResolvedUserName().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvedUserName().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvedUserName().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvedUserName, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvedUserName, "runtime", proto3);
_define_property(ResolvedUserName, "typeName", "mono.auth.v1.ResolvedUserName");
_define_property(ResolvedUserName, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
